
import { Course } from '../types';

export const children_act: Course = {
  id: "children_act",
  title: "The Children Act 1989",
  description: "The legal foundation of all family proceedings. Master the Welfare Checklist and Section 8 orders.",
  icon: "⚖️",
  totalModules: 10,
  modules: {
    1: { id: 1, title: "Slide 1", slides: [{ title: "Slide 1", content: `<div class="flex justify-center"><img src="/images/courses/children_act/Slide1.PNG" alt="Slide 1" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    2: { id: 2, title: "Slide 2", slides: [{ title: "Slide 2", content: `<div class="flex justify-center"><img src="/images/courses/children_act/Slide2.PNG" alt="Slide 2" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    3: { id: 3, title: "Slide 3", slides: [{ title: "Slide 3", content: `<div class="flex justify-center"><img src="/images/courses/children_act/Slide3.PNG" alt="Slide 3" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    4: { id: 4, title: "Slide 4", slides: [{ title: "Slide 4", content: `<div class="flex justify-center"><img src="/images/courses/children_act/Slide4.PNG" alt="Slide 4" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    5: { id: 5, title: "Slide 5", slides: [{ title: "Slide 5", content: `<div class="flex justify-center"><img src="/images/courses/children_act/Slide5.PNG" alt="Slide 5" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    6: { id: 6, title: "Slide 6", slides: [{ title: "Slide 6", content: `<div class="flex justify-center"><img src="/images/courses/children_act/Slide6.PNG" alt="Slide 6" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    7: { id: 7, title: "Slide 7", slides: [{ title: "Slide 7", content: `<div class="flex justify-center"><img src="/images/courses/children_act/Slide7.PNG" alt="Slide 7" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    8: { id: 8, title: "Slide 8", slides: [{ title: "Slide 8", content: `<div class="flex justify-center"><img src="/images/courses/children_act/Slide8.PNG" alt="Slide 8" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    9: { id: 9, title: "Slide 9", slides: [{ title: "Slide 9", content: `<div class="flex justify-center"><img src="/images/courses/children_act/Slide9.PNG" alt="Slide 9" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    10: { id: 10, title: "Slide 10", slides: [{ title: "Slide 10", content: `<div class="flex justify-center"><img src="/images/courses/children_act/Slide10.PNG" alt="Slide 10" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] }
  },
  quiz: [
    {
        "q": "According to Section 1(1) of the Children Act 1989, what is the court's paramount consideration in all decisions relating to a child?",
        "o": [
            "Parental rights",
            "A parent's capacity to provide financially",
            "The child's welfare",
            "The parents' wishes and feelings"
        ],
        "a": 2
    },
    {
        "q": "Under the Section 1(5) 'No Order' Principle, when will the court make an order?",
        "o": [
            "When parents fail to reach any agreement",
            "Only if it is clearly better for the child than making no order at all",
            "When one parent requests a formal order",
            "To establish clear parental rights for both parents"
        ],
        "a": 1
    },
    {
        "q": "Which of the following Section 8 Orders is used to prevent a parent from taking a specific action, such as moving a child out of the country, without court permission?",
        "o": [
            "Child Arrangements Order (CAO)",
            "Prohibited Steps Order (PSO)",
            "Specific Issue Order (SIO)",
            "Parental Responsibility Order (PRO)"
        ],
        "a": 1
    },
    {
        "q": "If a parent has Parental Responsibility, for which decision is there a legal duty to consult the other parent?",
        "o": [
            "Deciding what the child eats for dinner",
            "Choosing the child's daily clothes",
            "Agreeing on the child's bedtime during your agreed time",
            "Medical operations or changing schools"
        ],
        "a": 3
    },
    {
        "q": "In the Children Act 1989 Strategic Cheat Sheet, which principle forms the very top tier, acting as 'The Filter'?",
        "o": [
            "The Section 1(5) No Order Principle",
            "The Section 1(3) Welfare Checklist",
            "The Section 1(1) Paramount Consideration (Child's Welfare)",
            "The Section 8 Orders (CAO, PSO, SIO)"
        ],
        "a": 2
    }
]
};
